import React from "react";
import AllJobs from "./RecruitmentJobTabs/AllJobs";
import MyJobs from "./RecruitmentJobTabs/MyJobs";
import { NewTab, PageTabAdv } from "../../../components";

const RecruitmentJobs = () => {
  const RecruitmentJobsMenus = [
    {
      title: "All Jobs",
      page: <AllJobs />,
      type: "main",
      id: "all_jobs",
    },
    {
      title: "My Jobs",
      page: <MyJobs />,
      type: "main",
      id: "my_jobs",
    },
  ];
  return (
    <div className="flex-1 flex overflow-hidden">
      <NewTab
        tabs={RecruitmentJobsMenus}
        color="black"
        variant="outlined"
        mode="url"
        tabId="recruitment_jobs"
      />
    </div>
  );
};

export default RecruitmentJobs;
